module.exports = __webpack_public_path__ + "static/p1-77965e82f9521e74ae8e9fb33101b769.jpg";